import React, {useEffect, useState} from 'react';
import {Link as RouterLink, useParams} from "react-router-dom";

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Box from "@mui/material/Box";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import {lightGreen} from "@mui/material/colors";

import EvvForm from "../../components/evv/EvvForm";
import EmployeeService from "../../services/employee.service";
import AssignClient from "../../components/dashboard/AssignClient";

const DbEmpDetailsPage = () => {
    const [value, setValue] = useState("1");
    const [empInfo, setEmpInfo] = useState(null);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    let {empId} = useParams();

    const fetchData = (dataId) => {
        EmployeeService.getDocById(dataId).then((docSnap) => {
            if (docSnap.exists()) {
                setEmpInfo({id: docSnap.id, ...docSnap.data()});
            }
        });
    }

    useEffect(() => {
        if (empId){
            fetchData(empId);
        }
    }, [empId]);

    return (
        <React.Fragment>
            <Container maxWidth="xl">
                <Breadcrumbs aria-label="breadcrumb" sx={{mt: 1, p: 1}}>
                    <Link underline="hover" color="inherit" component={RouterLink} to={"/dashboard"}>
                        Dashboard
                    </Link>
                    <Link
                        underline="hover"
                        color="inherit"
                        component={RouterLink} to={"/dashboard/employees"}
                    >
                        Employees
                    </Link>
                    <Typography color="text.primary">Employee Details</Typography>
                </Breadcrumbs>
                <Box sx={{width: '100%', typography: 'body1'}}>
                    <Card sx={{minWidth: 275, borderRadius: 0}}>
                        <CardContent sx={{p:0,'&:last-child': {pb:0}}}>
                            <Box sx={{
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'row'
                            }}
                            >
                                <Avatar
                                    variant="square"
                                    src="/broken-image.jpg"
                                    sx={{height: 64, mr: 1, width: 64, bgcolor: lightGreen[300]}}
                                />
                                <Typography
                                    color="textPrimary"
                                    gutterBottom
                                    variant="h5"
                                >
                                    {empInfo?.empName}
                                </Typography>
                            </Box>
                        </CardContent>
                    </Card>
                    <TabContext value={value}>
                        <Box sx={{borderBottom: 1, borderColor: 'divider', bgcolor: lightGreen[50]}}>
                            <TabList onChange={handleChange}
                                     scrollButtons="auto"
                                     variant="scrollable"
                                     aria-label="employees actions">
                                <Tab label="Apply Missed Evv" value="1"/>
                                <Tab label="Missed Evv Stats" value="2"/>
                                <Tab label="Client List" value="3"/>
                                <Tab label="Manage Signatures" value="4"/>
                            </TabList>
                        </Box>
                        <TabPanel value="1">
                            <EvvForm applyFor={empInfo} />
                        </TabPanel>
                        <TabPanel value="2">
                            One two
                        </TabPanel>
                        <TabPanel value="3">
                            <AssignClient emp={empInfo} reFetch={fetchData} />
                        </TabPanel>
                        <TabPanel value="4">Empty.</TabPanel>
                    </TabContext>
                </Box>
            </Container>
        </React.Fragment>
);
};

export default DbEmpDetailsPage;